import React, { useEffect, useState } from "react";
import {
  TextField,
  Typography,
  Button,
  Chip,
  Select,
  MenuItem,
  ListItemText,
  IconButton,
  Box,
  List,
  ListItem,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  InputLabel,
  LinearProgress,
  Tabs,
  Tab,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useSelector } from "react-redux";
import json5 from "json5";

import RadioButtonsGroup from "../../../Component/UI/RadioGroup/RadioGroup";
import TextInput from "../../../Component/UI/TextInput/TextInput";
import {
  getPromptForBrandCompetitorsData,
  validateProductInput,
} from "../../../utils/helpers";
import { fetchGpt4API } from "../../../services/apiService";
import InputSelectionComponent from "../../Dashboard/Component/inputSelection";
import api from "../../../BrandOnBoarding/api";
import MUIChip from "../../../Component/UI/MUIChip/MUIChip";
import MUISelect from "../../../Component/UI/MUISelect/MUISelect";
import Modal from "../../../Component/Modal/Modal";
import { ENTITY_LABELS } from "../../../utils/labelMapping";

const radioOption = [
  {
    value: "manual",
    label: "Enter Competitors Manually",
  },
  {
    value: "ai",
    label: "Add Competitors from AI Suggestion",
  },
];
const Addproduct = ({
  productName,
  setProductName,
  classes,
  handleCloseModal,
  createNewproduct,
  updateCreatedProduct,
  isUpdateModalOpen,
}) => {
  const [brandData, setBrandData] = useState({
    productName,
    categories: [], // <-- dynamic categories array
  });

  const [newCategory, setNewCategory] = useState({
    name: "",
    description: "",
  });

  const [currentCategories, setCurrentCategories] = useState([]);

  const [selectedCategoryIndex, setSelectedCategoryIndex] = useState(0);

  const brands = useSelector((state) => state.brands);

  const personas = useSelector((state) => state.personas);
  const personasData = personas.data.data;
  const [selectedBrand, setSelectedBrand] = useState("");

  const [prevProductName, setPrevProductName] = useState("");

  const [showManualVariantDialog, setShowManualVariantDialog] = useState(false);

  const handleCompetitorToggle = (competitor) => {
    if (
      brandData.categories?.[selectedCategoryIndex]?.competitors?.includes(
        competitor
      )
    ) {
      const updated = [...brandData.categories];

      const updatedComps = [
        ...updated[selectedCategoryIndex].competitors,
      ].filter((c) => c !== competitor);

      updated[selectedCategoryIndex] = {
        ...updated[selectedCategoryIndex],
        competitors: updatedComps,
      };
      setBrandData({ ...brandData, categories: updated });
    } else {
      const updated = [...brandData.categories];

      const updatedComps = [
        ...updated[selectedCategoryIndex].competitors,
        competitor,
      ];

      updated[selectedCategoryIndex] = {
        ...updated[selectedCategoryIndex],
        competitors: updatedComps,
      };
      setBrandData({ ...brandData, categories: updated });
    }
  };

  useEffect(() => {
    if (brandData?.categories?.[selectedCategoryIndex]?.name) {
      fetchLLMProductDimensions();
    }
  }, [productName, brandData.categories.length]);

  const updateCategoryPurchaseCriterias = async () => {
    try {
      setBrandData((prev) => {
        const updated = [...prev.categories];
        updated[selectedCategoryIndex] = {
          ...updated[selectedCategoryIndex],
          purchaseCriteriaLoading: true,
        };
        return { ...prev, categories: updated };
      });

      let res = await fetch(
        `${process.env.REACT_APP_BASE_URL}/metrics/generate-category-dimensions`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          method: "POST",
          body: JSON.stringify({
            llm: "gpt-4o",
            brand: productName,
            category: brandData.categories?.[selectedCategoryIndex].name,
          }),
        }
      );
      res = await res.json();
      res = res.map((item) => item.name);

      setBrandData((prev) => {
        const updated = [...prev.categories];
        updated[selectedCategoryIndex] = {
          ...updated[selectedCategoryIndex],
          purchaseCriteria: res,
          purchaseCriteriaLoading: false,
        };
        return { ...prev, categories: updated };
      });
    } catch (error) {
      console.error("Error fetching purchase criteria:", error);

      setBrandData((prev) => {
        const updated = [...prev.categories];
        updated[selectedCategoryIndex] = {
          ...updated[selectedCategoryIndex],
          purchaseCriteriaLoading: false,
        };
        return { ...prev, categories: updated };
      });
    }
  };

  useEffect(() => {
    if (productName && brandData?.categories?.[selectedCategoryIndex]?.name) {
      updateCategoryPurchaseCriterias();
    }
  }, [productName, brandData.categories.length]);

  const handlePersonaCheckChange = (selected) => {
    const selectedValues =
      selected?.map((option) => option?.persona?.name) || [];

    // Update category-specific persona and personaLabel
    const updated = [...brandData.categories];
    updated[selectedCategoryIndex] = {
      ...updated[selectedCategoryIndex],
      persona: selected,
      personaLabel: selectedValues,
    };

    setBrandData({ ...brandData, categories: updated });
  };

  const handleEdit = (categoryIndex, subcategoryIndex) => {
    const updated = [...brandData.categories];
    updated[selectedCategoryIndex] = {
      ...updated[selectedCategoryIndex],
      editing: { categoryIndex, subcategoryIndex },
      editedValue:
        updated[selectedCategoryIndex]?.productDimensions?.[categoryIndex]
          ?.subcategories?.[subcategoryIndex],
    };

    setBrandData({ ...brandData, categories: updated });
  };

  const handleSave = (categoryIndex, subcategoryIndex) => {
    const updated = [...brandData.categories];
    updated[selectedCategoryIndex] = {
      ...updated[selectedCategoryIndex],
      editing: null,
    };

    const updatedProuctDims = [
      ...updated[selectedCategoryIndex].productDimensions,
    ];

    updatedProuctDims[categoryIndex].subcategories[subcategoryIndex] =
      updated[selectedCategoryIndex]?.editedValue;

    setBrandData({ ...brandData, categories: updated });
  };

  const handleDoubleClick = (index, value) => {
    const updated = [...brandData.categories];
    updated[selectedCategoryIndex] = {
      ...updated[selectedCategoryIndex],
      editedText: value,
      editingIndex: index,
    };
    setBrandData({ ...brandData, categories: updated });
  };

  const handleInputChange = (event) => {
    const updated = [...brandData.categories];
    updated[selectedCategoryIndex] = {
      ...updated[selectedCategoryIndex],
      editedText: event.target.value,
    };

    setBrandData({ ...brandData, categories: updated });
  };

  const handleBlur = () => {
    if (
      brandData.categories?.[selectedCategoryIndex].editedText &&
      brandData.categories?.[selectedCategoryIndex].editingIndex !== null
    ) {
      const updated = [...brandData.categories];

      const updatedPurchaseCriteria = [
        ...updated[selectedCategoryIndex].purchaseCriteria,
      ];

      updatedPurchaseCriteria[updated[selectedCategoryIndex].editingIndex] =
        updated[selectedCategoryIndex].editedText.trim();
      updated[selectedCategoryIndex] = {
        ...updated[selectedCategoryIndex],
        purchaseCriteria: updatedPurchaseCriteria,
        editingIndex: null,
      };
      setBrandData({ ...brandData, categories: updated });
    } else {
      const updated = [...brandData.categories];
      updated[selectedCategoryIndex] = {
        ...updated[selectedCategoryIndex],
        editingIndex: null,
      };
      setBrandData({ ...brandData, categories: updated });
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleBlur();
    }
  };

  async function getCompetitorsData(type) {
    if (
      type === "ai" &&
      productName &&
      (prevProductName !== productName ||
        !currentCategories.includes(
          brandData.categories?.[selectedCategoryIndex]?.name
        ))
    ) {
      const customerBrand = brands?.data?.data.find(
        (brand) => brand.brand.id === selectedBrand
      );
      const brandName = customerBrand?.brand?.name ?? "";
      let prompt = getPromptForBrandCompetitorsData(
        brandName + " " + productName,
        "product",
        brandData.categories?.[selectedCategoryIndex]?.name
      );

      setBrandData((prev) => {
        const updated = [...prev.categories];
        updated[selectedCategoryIndex] = {
          ...updated[selectedCategoryIndex],
          competitorsLoading: true,
        };
        return { ...prev, categories: updated };
      });

      try {
        let result = await fetchGpt4API(
          prompt,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          "Brand-onboarding"
        );
        result = result["GPT-4"][0];

        let matchedArray = result.match(
          /\[\s*\{[^\}]*\}\s*(,\s*\{[^\}]*\}\s*)*\]/g
        );

        if (matchedArray) {
          let resultArray = json5.parse(matchedArray[0]);

          // 🔄 Set competitorsFromAi + loading = false safely
          setBrandData((prev) => {
            const updated = [...prev.categories];
            updated[selectedCategoryIndex] = {
              ...updated[selectedCategoryIndex],
              competitorsLoading: false,
              competitorsFromAi: resultArray,
            };
            return { ...prev, categories: updated };
          });

          setPrevProductName(productName);
          setCurrentCategories((prev) => [
            ...new Set([
              ...prev,
              brandData.categories?.[selectedCategoryIndex]?.name,
            ]),
          ]);
        }
      } catch (err) {
        // 🔄 Set loading = false safely on error
        setBrandData((prev) => {
          const updated = [...prev.categories];
          updated[selectedCategoryIndex] = {
            ...updated[selectedCategoryIndex],
            competitorsLoading: false,
          };
          return { ...prev, categories: updated };
        });
      }
    }
  }

  const fetchLLMProductDimensions = async () => {
    try {
      setBrandData((prev) => {
        const updated = [...prev.categories];
        updated[selectedCategoryIndex] = {
          ...updated[selectedCategoryIndex],
          productDimensionsLoading: true,
        };
        return { ...prev, categories: updated };
      });
      let res = await api.post(`/metrics/product-dimensions`, {
        llm: "gpt-4o",
        category: brandData?.categories?.[selectedCategoryIndex]?.name,
      });
      res = res.data;

      setBrandData((prev) => {
        const updated = [...prev.categories];
        updated[selectedCategoryIndex] = {
          ...updated[selectedCategoryIndex],
          productDimensions: res.data,
        };
        return { ...prev, categories: updated };
      });
    } catch (error) {
      console.error("Error fetching purchase criteria:", error);
    } finally {
      setBrandData((prev) => {
        const updated = [...prev.categories];
        updated[selectedCategoryIndex] = {
          ...updated[selectedCategoryIndex],
          productDimensionsLoading: false,
        };
        return { ...prev, categories: updated };
      });
    }
  };

  const processInputData = (data) => {
    const modifiedresults = data?.categories?.map((obj) => {
      return {
        category_name: obj?.name,
        category_description: obj?.description,
        comp_products: obj?.competitors,
        personaIds: obj?.persona?.map((item) => item?.persona_id),
        productDimensions: obj?.productDimensions,
        purchaseCriteria: obj?.purchaseCriteria,
        variants: obj?.productVariants,
      };
    });

    return {
      product_name: productName,
      brand_id: selectedBrand,
      categories: modifiedresults,
    };
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    const input = processInputData(brandData);

    console.log('input==>', input, 'branddata==>', JSON.stringify(brandData))

    const hasTooManyCompProducts = input?.categories?.some(
      (category) => category?.comp_products?.length > 4
    );

    if (hasTooManyCompProducts) {
      alert("You can only select up to 4 competitors.");
      return;
    }

    // if (input.categories?.productDimensions?.length !== 5) {
    //   alert("Please add Product dimensions");
    //   return;
    // }
    // if (input.categories?.personaIds?.length === 0) {
    //   alert("Please select personas");
    //   return;
    // }
    // if (input.categories?.purchaseCriteria?.length !== 5) {
    //   alert("Please add purchase criteria");
    //   return;
    // }

    if (isUpdateModalOpen) {
      updateCreatedProduct(input);
    } else {
      createNewproduct(input);
    }
  };

  async function checkProductAndGetVariants(name, category) {
    try {
      const response = await validateProductInput(name, category);
      const variants = response?.data?.variants || [];
      const updatedVariants = variants.map((variant) => {
        return {
          id: variant,
          name: variant,
          value: variant,
        };
      });

      setBrandData((prev) => {
        const updated = [...prev.categories];
        updated[selectedCategoryIndex] = {
          ...updated[selectedCategoryIndex],
          productVariants: [
            ...updatedVariants,
            { id: 0, name: "Add Manually", value: "add_manually" },
          ],
          productVariantsLoading: true,
        };
        return { ...prev, categories: updated };
      });
    } catch (error) {
      console.log("Unable to fetch product variants");
    } finally {
      setBrandData((prev) => {
        const updated = [...prev.categories];
        updated[selectedCategoryIndex] = {
          ...updated[selectedCategoryIndex],
          productVariantsLoading: false,
        };
        return { ...prev, categories: updated };
      });
    }
  }

  useEffect(() => {
    if (!productName || !brandData.categories?.[selectedCategoryIndex]?.name)
      return;
    const timeoutId = setTimeout(() => {
      checkProductAndGetVariants(
        productName,
        brandData.categories?.[selectedCategoryIndex]?.name
      );
    });
    return () => {
      clearTimeout(timeoutId);
    };
  }, [brandData.categories?.[selectedCategoryIndex]?.name, productName]);

  function handleAddNewUserVariant() {
    setShowManualVariantDialog(false);

    setBrandData((prev) => {
      const updated = [...prev.categories];
      const itemIndex = updated[
        selectedCategoryIndex
      ]?.selectedVariants.findIndex(
        (item) =>
          item.name.toString().toLowerCase().trim() ===
          updated[selectedCategoryIndex]?.userEnteredVariant
            .toString()
            .toLowerCase()
            .trim()
      );

      let varaints = [];
      if (itemIndex > -1) {
        varaints = updated[selectedCategoryIndex]?.selectedVariants;
      } else {
        varaints = [
          {
            id: Math.random(),
            name: updated[selectedCategoryIndex]?.userEnteredVariant,
            value: updated[selectedCategoryIndex]?.userEnteredVariant,
          },
          ...updated[selectedCategoryIndex]?.selectedVariants,
        ];
      }

      updated[selectedCategoryIndex] = {
        ...updated[selectedCategoryIndex],
        selectedVariants: varaints,
      };
      return { ...prev, categories: updated };
    });
  }

  const isValid =
    Array.isArray(brandData.categories) &&
    brandData.categories.length > 0 &&
    brandData.categories.every((category) =>
      ["persona", "competitors", "purchaseCriteria", "productDimensions"].every(
        (key) => Array.isArray(category[key]) && category[key].length > 0
      )
    );

  return (
    <form onSubmit={handleFormSubmit}>
      <div className={classes.modalBody}>
        <Select
          value={selectedBrand}
          onChange={(e) => setSelectedBrand(e.target.value)}
          displayEmpty
          fullWidth
          required
          className={classes.select}
        >
          <MenuItem value="">Select {ENTITY_LABELS.brand}</MenuItem>
          {brands?.data?.data &&
            brands?.data?.data.length !== 0 &&
            brands?.data?.data
              .filter((obj) => obj?.is_active)
              .map((brand) => (
                <MenuItem value={brand?.brand?.id}>
                  {brand?.brand?.name}
                </MenuItem>
              ))}
        </Select>
        <p></p>
        <div>
          <TextInput
            label={`${ENTITY_LABELS.product} Name`}
            variant="outlined"
            fullWidth
            required
            value={productName}
            onChange={(e) => {
              setProductName(e.target.value);
            }}
            className={classes.textField}
          />
        </div>
        <p></p>
        <Box style={{ display: "flex", alignItems: "center" }} gap={2}>
          <TextInput
            className={classes.textField}
            label="Category Name"
            value={newCategory.name}
            onChange={(e) =>
              setNewCategory({ ...newCategory, name: e.target.value })
            }
          />
          <TextInput
            className={classes.textField}
            label="Category Description"
            value={newCategory.description}
            onChange={(e) =>
              setNewCategory({ ...newCategory, description: e.target.value })
            }
          />
          <Button
            style={{ height: "35px", marginTop: "17px" }}
            variant="contained"
            disabled={
              brandData?.categories?.[selectedCategoryIndex]
                ?.purchaseCriteriaLoading ||
              brandData?.categories?.[selectedCategoryIndex]
                ?.productDimensionsLoading ||
              brandData?.categories?.[selectedCategoryIndex]
                ?.productVariantsLoading ||
              brandData?.categories?.[selectedCategoryIndex]
                ?.competitorsLoading ||
              !productName ||
              !newCategory?.name ||
              !newCategory?.description
            }
            onClick={() => {
              if (newCategory.name.trim()) {
                setBrandData((prev) => ({
                  ...prev,
                  categories: [
                    ...prev.categories,
                    {
                      ...newCategory,
                      competitors: [],
                      productDimensions: [],
                      productDimensionsLoading: false,
                      competitorsLoading: false,
                      competitorsFromAi: [],
                      competitorsSource: "manual",
                      purchaseCriteria: [],
                      purchaseCriteriaLoading: false,
                      persona: [],
                      personaLabel: [],
                      editingIndex: null,
                      editedText: "",
                      editing: { categoryIndex: null, subcategoryIndex: null },
                      editedValue: "",
                      productVariantsLoading: false,
                      productVariants: [],
                      selectedVariants: [],
                      userEnteredVariant: "",
                    },
                  ],
                }));
                setNewCategory({ name: "", description: "" });
                setSelectedCategoryIndex(brandData?.categories?.length);
              }
            }}
          >
            +
          </Button>
        </Box>

        <Tabs
          value={selectedCategoryIndex}
          onChange={(_, newIndex) => {
            const current = brandData.categories[selectedCategoryIndex];
            const target = brandData.categories[newIndex];

            if (
              current.purchaseCriteriaLoading ||
              current.competitorsLoading ||
              current.productDimensionsLoading ||
              current.productVariantsLoading ||
              target.purchaseCriteriaLoading ||
              target.competitorsLoading ||
              target.productDimensionsLoading ||
              target.productVariantsLoading
            ) {
              // Prevent switching
              return;
            }

            setSelectedCategoryIndex(newIndex);
          }}
        >
          {brandData.categories.map((cat, index) => (
            <Tab key={index} label={cat.name} />
          ))}
        </Tabs>

        {brandData?.categories?.[selectedCategoryIndex] && (
          <>
            <Box className="mt-4">
              <InputLabel shrink htmlFor="input">
                {ENTITY_LABELS.brand} Category Competitor
              </InputLabel>
              <RadioButtonsGroup
                key={
                  brandData.categories?.[selectedCategoryIndex]
                    ?.competitorsSource || "default"
                }
                options={radioOption}
                selectedvalue={
                  brandData.categories?.[selectedCategoryIndex]
                    ?.competitorsSource
                }
                onChange={(v) => {
                  const updated = [...brandData.categories];
                  updated[selectedCategoryIndex] = {
                    ...updated[selectedCategoryIndex],
                    competitorsSource: v,
                    competitors: [],
                  };

                  setBrandData({ ...brandData, categories: updated });
                  getCompetitorsData(v);
                }}
              ></RadioButtonsGroup>
            </Box>

            <Box className="mt-2">
              <TextInput
                label={`Competitors ${ENTITY_LABELS.brand} Description`}
                variant="outlined"
                fullWidth
                margin="normal"
                required
                value={brandData.categories[
                  selectedCategoryIndex
                ].competitors?.join(", ")}
                onChange={(e) => {
                  const updated = [...brandData.categories];
                  updated[selectedCategoryIndex].competitors = e.target.value
                    .split(",")
                    .map((val) => val.trim());
                  setBrandData({ ...brandData, categories: updated });
                }}
                // className={classes.select}
              />
              <Typography
                color="textDisabled"
                variant="caption"
                sx={{ fontSize: "8px" }}
              >
                Please add multiple inputs separated by comma (max 4)
              </Typography>
            </Box>
            {brandData.categories?.[selectedCategoryIndex]
              ?.competitorsLoading && <LinearProgress />}
            <Box className="mt-1">
              {
                // brandData.categories?.[selectedCategoryIndex]
                //   ?.competitorsSource === "ai" &&
                brandData.categories?.[
                  selectedCategoryIndex
                ]?.competitorsFromAi?.map((competitor, index) => (
                  <Chip
                    style={{ margin: "5px", borderRadius: "3px" }}
                    key={competitor}
                    label={competitor.comp_product_name}
                    onClick={() =>
                      handleCompetitorToggle(competitor.comp_product_name)
                    }
                    color={
                      brandData.categories?.[
                        selectedCategoryIndex
                      ]?.competitors?.includes(competitor.comp_product_name)
                        ? "primary"
                        : "default"
                    }
                  />
                ))
              }
            </Box>
            {showManualVariantDialog && (
              <Modal
                title="Add variant"
                open={showManualVariantDialog}
                handleClose={() => setShowManualVariantDialog(false)}
                showActions
                confirmBtnText="Add"
                confirmBtnDisabled={
                  brandData.categories?.[
                    selectedCategoryIndex
                  ]?.userEnteredVariant.trim().length === 0
                }
                handleConfirm={handleAddNewUserVariant}
              >
                <TextInput
                  label="Variant Name"
                  fullWidth
                  onChange={(e) => {
                    setBrandData((prev) => {
                      const updated = [...prev.categories];
                      updated[selectedCategoryIndex] = {
                        ...updated[selectedCategoryIndex],
                        userEnteredVariant: e.target.value,
                      };
                      return { ...prev, categories: updated };
                    });
                  }}
                />
              </Modal>
            )}

            <div className="mt-3 mb-1">
              <MUISelect
                loading={
                  brandData.categories?.[selectedCategoryIndex]
                    ?.productVariantsLoading
                }
                optionValue=""
                label={`${ENTITY_LABELS.product} Variants`}
                options={
                  brandData.categories?.[selectedCategoryIndex]?.productVariants
                }
                onChange={(e) => {
                  if (e.target.value === "add_manually") {
                    setShowManualVariantDialog(true);
                    return;
                  }

                  setBrandData((prev) => {
                    const updated = [...prev.categories];
                    const variantItem = updated[
                      selectedCategoryIndex
                    ]?.productVariants?.find(
                      (pv) => pv.value === e.target.value
                    );

                    if (variantItem) {
                      const itemIndex = updated[
                        selectedCategoryIndex
                      ]?.selectedVariants.findIndex(
                        (item) => item.id === variantItem.id
                      );
                      if (itemIndex > -1) {
                        updated[selectedCategoryIndex] = {
                          ...updated[selectedCategoryIndex],
                          selectedVariants:
                            updated[selectedCategoryIndex]?.selectedVariants,
                        };
                      } else {
                        updated[selectedCategoryIndex] = {
                          ...updated[selectedCategoryIndex],
                          selectedVariants: [
                            ...updated[selectedCategoryIndex]?.selectedVariants,
                            variantItem,
                          ],
                        };
                      }
                    }

                    return { ...prev, categories: updated };
                  });
                }}
              />
              <div className="mt-2">
                {brandData.categories?.[
                  selectedCategoryIndex
                ]?.selectedVariants.map((variant) => {
                  return (
                    <MUIChip
                      key={variant.id}
                      style={{ marginTop: 2, marginBottom: 2, marginRight: 2 }}
                      label={variant.name}
                      onDelete={() => {
                        setBrandData((prev) => {
                          const updated = [...prev.categories];
                          const category = {
                            ...updated[selectedCategoryIndex],
                          };

                          category.selectedVariants =
                            category.selectedVariants.filter(
                              (item) => item.id !== variant.id
                            );

                          updated[selectedCategoryIndex] = category;

                          return { ...prev, categories: updated };
                        });
                      }}
                    />
                  );
                })}
              </div>
            </div>

            {!isUpdateModalOpen && (
              <Box mt={2}>
                <InputLabel shrink htmlFor="input">
                  {ENTITY_LABELS.purchaseCriteria}
                </InputLabel>
                {brandData.categories?.[selectedCategoryIndex]
                  .purchaseCriteriaLoading && (
                  <LinearProgress className="mb-2" />
                )}
                {brandData.categories?.[selectedCategoryIndex]?.purchaseCriteria
                  ?.length === 0 && (
                  <Typography color="error" variant="caption" mt={1}>
                    Please enter brand name and brand category.
                  </Typography>
                )}
                <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                  {brandData.categories?.[
                    selectedCategoryIndex
                  ].purchaseCriteria.map((tag, index) => (
                    <Box key={index}>
                      {brandData.categories?.[selectedCategoryIndex]
                        .editingIndex === index ? (
                        <TextField
                          value={
                            brandData.categories?.[selectedCategoryIndex]
                              .editedText
                          }
                          onChange={handleInputChange}
                          onBlur={handleBlur}
                          onKeyPress={handleKeyPress}
                          size="small"
                          variant="outlined"
                          autoFocus
                        />
                      ) : (
                        <Chip
                          label={tag}
                          color="primary"
                          variant="outlined"
                          title="Double click to edit"
                          onDoubleClick={() => handleDoubleClick(index, tag)}
                        />
                      )}
                    </Box>
                  ))}
                </Box>
              </Box>
            )}

            <Box sx={{ margin: "auto" }}>
              <InputLabel shrink htmlFor="input">
                {ENTITY_LABELS.productDimension}*{" "}
                {brandData.categories?.[selectedCategoryIndex]
                  ?.productDimensions.length == 0 && (
                  <Typography color="error" variant="caption" mt={1}>
                    (Enter product category to populate {ENTITY_LABELS.productDimension}.)
                  </Typography>
                )}
              </InputLabel>
              {brandData.categories?.[selectedCategoryIndex]
                ?.productDimensionsLoading && <LinearProgress />}
              {brandData.categories?.[selectedCategoryIndex]?.productDimensions
                .length > 0 && (
                <Box sx={{ mt: 1 }}>
                  {brandData.categories?.[
                    selectedCategoryIndex
                  ]?.productDimensions.map((category, categoryIndex) => (
                    <Accordion
                      key={category.name}
                      sx={{ mb: 2, borderRadius: 2 }}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        sx={{
                          backgroundColor: "#dcebfb", // Your desired color
                          color: "rgba(0, 0, 0, 0.6)",
                          "&:hover": {
                            color: "white",
                            backgroundColor: "#7eb7ef", // Optional hover effect
                          },
                          padding: "4px 16px", // Reduce padding
                          minHeight: "32px", // Set a smaller minimum height
                          "& .MuiAccordionSummary-content": {
                            margin: 0, // Remove default margin
                            alignItems: "center", // Center content vertically
                          },
                        }}
                      >
                        <Typography variant="body2">{category.name}</Typography>
                      </AccordionSummary>
                      <AccordionDetails
                        sx={{ backgroundColor: "#fafafa", padding: "8px 10px" }}
                      >
                        <List>
                          {category.subcategories.map(
                            (subcategory, subcategoryIndex) => (
                              <ListItem
                                key={subcategoryIndex}
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  padding: "2px",
                                  borderBottom: "1px solid #eee",
                                }}
                              >
                                {brandData.categories?.[selectedCategoryIndex]
                                  ?.editing?.categoryIndex === categoryIndex &&
                                brandData.categories?.[selectedCategoryIndex]
                                  ?.editing?.subcategoryIndex ===
                                  subcategoryIndex ? (
                                  <TextField
                                    value={
                                      brandData.categories?.[
                                        selectedCategoryIndex
                                      ]?.editedValue
                                    }
                                    onChange={(e) =>
                                      setBrandData((prev) => {
                                        const updated = [...prev.categories];
                                        updated[selectedCategoryIndex] = {
                                          ...updated[selectedCategoryIndex],
                                          editedValue: e.target.value,
                                        };
                                        return { ...prev, categories: updated };
                                      })
                                    }
                                    size="small"
                                    fullWidth
                                  />
                                ) : (
                                  <ListItemText
                                    primary={subcategory}
                                    primaryTypographyProps={{
                                      fontSize: "12px",
                                    }} // Smaller text
                                  />
                                )}
                                <IconButton
                                  edge="end"
                                  color="primary"
                                  onClick={() =>
                                    brandData.categories?.[
                                      selectedCategoryIndex
                                    ]?.editing?.categoryIndex ===
                                      categoryIndex &&
                                    brandData.categories?.[
                                      selectedCategoryIndex
                                    ]?.editing?.subcategoryIndex ===
                                      subcategoryIndex
                                      ? handleSave(
                                          categoryIndex,
                                          subcategoryIndex
                                        )
                                      : handleEdit(
                                          categoryIndex,
                                          subcategoryIndex
                                        )
                                  }
                                >
                                  {brandData.categories?.[selectedCategoryIndex]
                                    ?.editing?.categoryIndex ===
                                    categoryIndex &&
                                  brandData.categories?.[selectedCategoryIndex]
                                    ?.editing?.subcategoryIndex ===
                                    subcategoryIndex ? (
                                    <CheckIcon />
                                  ) : (
                                    <EditIcon fontSize="small" />
                                  )}
                                </IconButton>
                              </ListItem>
                            )
                          )}
                        </List>
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </Box>
              )}
            </Box>

            <Box mt={2}>
              <InputLabel shrink htmlFor="input">
                Persona
              </InputLabel>
              <InputSelectionComponent
                selectedOptions={
                  brandData?.categories?.[selectedCategoryIndex]?.personaLabel
                }
                handleChange={handlePersonaCheckChange}
                options={personasData}
                type="persona"
              />
              {brandData?.categories?.[selectedCategoryIndex]?.personaLabel
                ?.length === 0 && (
                <Typography color="error" variant="caption" mt={1}>
                  Please select a persona.
                </Typography>
              )}
            </Box>
          </>
        )}

        <div className={classes.buttonDiv}>
          <Button type="submit" variant="contained" disabled={!isValid}>
            <div>{isUpdateModalOpen ? "Update" : "Add"}</div>
          </Button>
          <Button variant="outlined" onClick={handleCloseModal}>
            Cancel
          </Button>
        </div>
      </div>
    </form>
  );
};

export default Addproduct;
